$(function () {
    if ($('.selectpicker').length) {
        $('.selectpicker').selectpicker({
            noneResultsText: 'Nic nenalezeno výraz {0}'
        });
    }
});